export default "__VITE_ASSET__DB0xxSJT__"